export const themesBase = {
  'default-dark': {
    contrast: '162 156 134',
    // 'contrast-l': '220 215 196',
    main: '8 11 15',
    'main-d': '0 0 0',
    'primary-l': '6 104 110',
    primary: '3 55 59',
    'primary-d': '21 28 36',
    // 'secondary-l': '197 128 53',
    secondary: '142 76 40',
    'secondary-d': '74 37 17',
    red: '87 0 0',
    orange: '74 37 17',
    yellow: '71 55 11',
    lime: '54 72 20',
    green: '20 72 33',
    blue: '20 55 87',
    purple: '59 40 87',
    pink: '87 40 72',
  },
  'default-light': {
    contrast: '60 60 65',
    // 'contrast-l': '10 10 15',
    main: '220 215 196',
    'main-d': '162 156 134',
    'primary-l': '56 154 160',
    primary: '96 194 200',
    'primary-d': '255 255 255',
    // 'secondary-l': '146 42 0',
    secondary: '196 92 35',
    'secondary-d': '236 132 75',
    red: '234 77 77',
    orange: '236 132 75',
    yellow: '234 200 77',
    lime: '166 212 110',
    green: '101 200 113',
    blue: '102 173 244',
    purple: '177 122 245',
    pink: '247 130 216',
  },
  'cold-dark': {
    contrast: '160 170 190',
    // 'contrast-l': '180 190 210',
    main: '5 15 30',
    'main-d': '0 0 0',
    'primary-l': '80 125 155',
    primary: '40 80 110',
    'primary-d': '15 25 45',
    // 'secondary-l': '150 80 20',
    secondary: '130 60 20',
    'secondary-d': '110 40 0',
    red: '87 0 0',
    orange: '74 37 17',
    yellow: '71 55 11',
    lime: '54 72 20',
    green: '20 72 33',
    blue: '20 55 87',
    purple: '59 40 87',
    pink: '87 40 72',
  },
  'cold-light': {
    contrast: '15 30 50',
    // 'contrast-l': '0 0 0',
    main: '230 240 250',
    'main-d': '200 210 230',
    'primary-l': '80 125 155',
    primary: '120 165 195',
    'primary-d': '255 255 255',
    // 'secondary-l': '146 42 0',
    secondary: '186 82 25',
    'secondary-d': '236 132 75',
    red: '234 77 77',
    orange: '236 132 75',
    yellow: '234 200 77',
    lime: '166 212 110',
    green: '101 200 113',
    blue: '102 173 244',
    purple: '177 122 245',
    pink: '247 130 216',
  },
};
